module.exports = __webpack_public_path__ + "img/Desktop.f1280330.png";